import { isEmptyScObj } from "../../utils/siteUtils";
import React, { useEffect, useState } from "react";
import api from "../../utils/api";
import Heading from "../../elements/heading";

import Input from "../../elements/input";
import { PrimaryButton, BodyText } from "../../elements";
import { setUserInfoAction } from "../../redux/actions";
import { selectUserState } from "../../selectors/application";
import { connect, useDispatch, useSelector } from "react-redux";
import { S_USER, webStorage } from "../../utils/webStorage";
import { isBizNull } from "../../utils";
import "./style.scss";
import { getUserInfo } from "../../services/userService";
import getSiteInfo from "../../utils/getSiteInfo";

function AccountProfileSetting(props) {
  if (isEmptyScObj(props)) {
    return null;
  } else {
    return <AccountProfileSettingMain {...{ ...props }} />;
  }
}
function AccountProfileSettingMain(props) {
  const {
    fields: {
      headingType,
      headingBody,
      firstNameLabel,
      firstNameMissingMessage,
      lastNameLabel,
      lastNameMissingMessage,
      birthdayLabel,
      birthdayInfoMessage,
      birthdayWarningMessage,
      // birthdayMissingMessage,
      ctaName,
      colorScheme,
      iconName,
      updateFailedMessage,
      updateSuccessMessage,
      birthdayUnder18Message
    }
  } = props;
  const [firstName, setFirstName] = useState(null);
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [lastNameError, setLastNameError] = useState(null);
  const [birthdayError, setBirthdayError] = useState(null);
  const [birthday, setBirthday] = useState(null);
  const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  const [hasServerError, setHasServerError] = useState();
  const [updateSuccess, setUpdateSuccess] = useState();

  /*Redux Start*/
  const dispatch = useDispatch();
  const user = useSelector(selectUserState);
  const setUserInfo = data => dispatch(setUserInfoAction(data));
  /*Redux End*/

  useEffect(() => {
    getUserInLatestFormat();
  }, []);

  useEffect(() => {
    setFirstName(user.firstName);
    setLastName(user.lastName);
    setBirthday(user.birthday);
  }, [user]);

  const getUserInLatestFormat = async () => {
    const _user = await getUserInfo();
    setUserInfo(_user);
  };
  const onBirthdayFocus = evt => {
    setBirthdayError(null);
    setHasServerError(null);
  };
  const onBirthdayChange = evt => {
    setBirthday(evt.target.value);
    setIsUpdateDisabled(false);
  };
  const onBirthdayBlur = (evt, isValid, isOver18) => {
    if (evt.target.value) {
      if (isValid) {
        if (!isOver18) {
          setBirthdayError(birthdayUnder18Message.value);
        } else {
          setBirthdayError(null);
        }
      } else {
        setBirthdayError(birthdayWarningMessage.value);
      }
    } else {
      setBirthdayError(null);
    }
  };

  const validateForm = () => {
    let result = true;
    if (isBizNull(firstName)) {
      setFirstNameError(firstNameMissingMessage.value);
      result = false;
    }
    if (isBizNull(lastName)) {
      setLastNameError(lastNameMissingMessage.value);
      result = false;
    }
    if (birthdayError) {
      result = false;
    }

    return result;
  };

  const onSubmitBirthdayChange = async evt => {
    if (validateForm()) {
      setIsUpdateDisabled(true);
      try {
        const siteInfo = await getSiteInfo();
        let data = {
          ...user,
          firstName,
          lastName,
          birthday,
          dateFormat: siteInfo.dateFormat
        };
        await api.user.update(null, data);

        setHasServerError(false);
        const updatedUser = await getUserInfo();
        setUserInfo(updatedUser);
        setUpdateSuccess(true);
      } catch (e) {
        setHasServerError(true);
      }
      setIsUpdateDisabled(false);
    }
  };
  const firstNameProps = {
    label: firstNameLabel.value,
    showError: !!firstNameError,
    warningMessage: firstNameError,
    maxLength: 25,
    value: firstName,
    onChange: evt => {
      setFirstName(evt.target.value);
      setIsUpdateDisabled(false);
    }
  };
  const lastNameProps = {
    label: lastNameLabel.value,
    showError: !!lastNameError,
    warningMessage: lastNameError,
    maxLength: 25,
    value: lastName,
    onChange: evt => {
      setLastName(evt.target.value);
      setIsUpdateDisabled(false);
    }
  };
  const dateOfBirthInputProps = {
    label: birthdayLabel.value,
    showError: !!birthdayError,
    infoMessage: birthdayInfoMessage.value,
    warningMessage: birthdayError,
    type: "dateOfBirth",
    value: birthday,
    onChange: (evt, isValid) => onBirthdayChange(evt, isValid),
    onFocus: evt => onBirthdayFocus(evt),
    onBlur: (evt, isValid, isOver18) => onBirthdayBlur(evt, isValid, isOver18)
  };

  const ctaChangeBirthday = {
    buttonText: ctaName.value,
    colorScheme: colorScheme,
    iconName: iconName,
    isDisabled: isUpdateDisabled,
    callback: evt => onSubmitBirthdayChange(evt)
  };
  return (
    <div className="section account-profile-setting">
      <Heading type={headingType} className="heading" typographyClass="type-h3" html={headingBody} />
      <Input {...firstNameProps} />
      <Input {...lastNameProps} />
      <Input {...dateOfBirthInputProps} />
      <PrimaryButton {...ctaChangeBirthday} />
      {updateSuccess && <BodyText html={updateSuccessMessage.value} />}
      {hasServerError && <BodyText html={updateFailedMessage.value} />}
    </div>
  );
}
export default AccountProfileSetting;
